import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[mobile-content]',
  standalone: false
})
export class MobileContentDirective {

  constructor(private el: ElementRef) {
    this.el.nativeElement.classList.add('mobile-content');
  }

}
